<script lang="ts" setup></script>
<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.62493 10.2155C6.466 10.2155 4.54609 11.2579 3.32376 12.8756C3.06069 13.2238 2.92915 13.3978 2.93345 13.6331C2.93678 13.8149 3.05092 14.0442 3.19394 14.1564C3.37906 14.3017 3.63559 14.3017 4.14866 14.3017H13.1012C13.6143 14.3017 13.8708 14.3017 14.0559 14.1564C14.1989 14.0442 14.3131 13.8149 14.3164 13.6331C14.3207 13.3978 14.1892 13.2238 13.9261 12.8756C12.7038 11.2579 10.7839 10.2155 8.62493 10.2155Z"
      fill="black"
    />
    <path
      d="M8.62493 8.17239C10.3175 8.17239 11.6896 6.8003 11.6896 5.10774C11.6896 3.41518 10.3175 2.04309 8.62493 2.04309C6.93237 2.04309 5.56028 3.41518 5.56028 5.10774C5.56028 6.8003 6.93237 8.17239 8.62493 8.17239Z"
      fill="black"
    />
    <path
      d="M8.62493 10.2155C6.466 10.2155 4.54609 11.2579 3.32376 12.8756C3.06069 13.2238 2.92915 13.3978 2.93345 13.6331C2.93678 13.8149 3.05092 14.0442 3.19394 14.1564C3.37906 14.3017 3.63559 14.3017 4.14866 14.3017H13.1012C13.6143 14.3017 13.8708 14.3017 14.0559 14.1564C14.1989 14.0442 14.3131 13.8149 14.3164 13.6331C14.3207 13.3978 14.1892 13.2238 13.9261 12.8756C12.7038 11.2579 10.7839 10.2155 8.62493 10.2155Z"
      stroke="black"
      stroke-width="1.36207"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.62493 8.17239C10.3175 8.17239 11.6896 6.8003 11.6896 5.10774C11.6896 3.41518 10.3175 2.04309 8.62493 2.04309C6.93237 2.04309 5.56028 3.41518 5.56028 5.10774C5.56028 6.8003 6.93237 8.17239 8.62493 8.17239Z"
      stroke="black"
      stroke-width="1.36207"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
